import { Translation } from 'cng-common/features/translations'
import { IColumn } from 'core-components/library/list/types'

import { ESP_TRANSLATION_KEYS } from '../../../configs/translations'
import { IEspSponsorRow } from '../../../lib/getEspDashboardStats'
import { EspBadge, TEspBadgeVariant } from '../../espBadge/EspBadge'

const KEYS = ESP_TRANSLATION_KEYS.dashboard

/** Green from 80%, amber from 50%, red below — matches the wireframe's chip colouring. */
const getRateVariant = (percent: number): TEspBadgeVariant => {
  if (percent >= 80) {
    return 'positive'
  }

  return percent >= 50 ? 'pending' : 'negative'
}

const renderRate = (percent: number | null) =>
  percent === null ? <>—</> : <EspBadge variant={getRateVariant(percent)} label={`${percent}%`} />

export const getSponsorColumns = (): IColumn<IEspSponsorRow>[] => [
  {
    field: 'sponsorName',
    title: KEYS.columnSponsor,
    disableSort: true,
    hideSettings: true,
    titleRender: () => <Translation text={KEYS.columnSponsor} />,
    renderFunction: (item) => <>{item.sponsorName}</>,
  },
  {
    field: 'partnersCount',
    title: KEYS.columnPartners,
    disableSort: true,
    hideSettings: true,
    titleRender: () => <Translation text={KEYS.columnPartners} />,
    renderFunction: (item) => <>{item.partnersCount}</>,
  },
  {
    field: 'coveragePercent',
    title: KEYS.columnCoverage,
    disableSort: true,
    hideSettings: true,
    titleRender: () => <Translation text={KEYS.columnCoverage} />,
    renderFunction: (item) => renderRate(item.coveragePercent),
  },
  {
    field: 'lastActivityDate',
    title: KEYS.columnLastEngagement,
    disableSort: true,
    hideSettings: true,
    titleRender: () => <Translation text={KEYS.columnLastEngagement} />,
    renderFunction: (item) => (
      <>{item.lastActivityDate ? new Date(item.lastActivityDate).toLocaleDateString() : '—'}</>
    ),
  },
]
